import { CommonState } from 'common/types'
import { DesignerStoreContentTabs, DesignerStoreTab, getDesignerStoreContentType } from 'common/constants'
import { fetchNews } from 'common/services/news'
import { StateKey } from 'common/utils/flipState'
import { NewsParam } from 'common/types/params'
import { ReduxCachedState, isCacheHit, createCacheParam } from 'common/utils/reduxCache'

export interface DesignerStoreTabs extends ReduxCachedState {
  storeId: string
  tabs: DesignerStoreTab[]
}

const initialState: DesignerStoreTabs = {
  storeId: null,
  tabs: [],
  cacheParam: null,
}

const FETCH = '/store/designer/contentTab/FETCH'

export const fetchDesignerStoreContentTabs = (curState: StateKey, storeId: string) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchDesignerStoreContentTabs', { curState, storeId })
  if (isCacheHit(getState().designerStoreContentTabs[curState], cacheParam)) {
    return
  }

  const contents = await Promise.all(
    DesignerStoreContentTabs.map(contentTab => {
      const newsParam: NewsParam = {
        storeId,
        page: 1,
        pageSize: 1,
        contentType: getDesignerStoreContentType(contentTab),
      }
      return fetchNews(newsParam)
    }),
  )

  const tabs = contents
    .filter(content => content.articles && content.articles.length)
    .map(content => content.contentType)

  dispatch({
    curState,
    storeId,
    tabs,
    cacheParam,
    type: FETCH,
  })
}

const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        storeId: action.storeId,
        tabs: action.tabs,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default tabReducer
